import { useEffect } from 'react';

import { updateFirstLoadedPageIfNecessary } from '../../../telemetry/firstLoadedPageStore';
import { subscribeToPageLoadEvent, unsubscribeFromPageLoadEvent } from '../../../telemetry/loadEvents';

export const useSetFirstLoadedPageSubscription = (): void => {
  useEffect(() => {
    subscribeToPageLoadEvent('Loaded', updateFirstLoadedPageIfNecessary);
    subscribeToPageLoadEvent('Interrupted', updateFirstLoadedPageIfNecessary);
    subscribeToPageLoadEvent('TimedOut', updateFirstLoadedPageIfNecessary);
    subscribeToPageLoadEvent('FailedRecoverable', updateFirstLoadedPageIfNecessary);

    return () => {
      unsubscribeFromPageLoadEvent('Loaded', updateFirstLoadedPageIfNecessary);
      unsubscribeFromPageLoadEvent('Interrupted', updateFirstLoadedPageIfNecessary);
      unsubscribeFromPageLoadEvent('TimedOut', updateFirstLoadedPageIfNecessary);
      unsubscribeFromPageLoadEvent('FailedRecoverable', updateFirstLoadedPageIfNecessary);
    };
  }, []);
};
